import React from 'react';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import Offers from './Offers';

interface MultipleOffersProps {
  offers: OfferOption[];
  selectedOffer: SelectedOffer;
  setSelectedOffer: (plan: SelectedOffer) => void;
}

const MultipleOffers = ({ offers, selectedOffer, setSelectedOffer }: MultipleOffersProps) => {
  return (
    <div>
      <div className="tw-mb-20 tw-mt-24 tw-flex tw-items-center">
        <div className="tw-font-sans tw-text-body-sm tw-font-bold tw-uppercase tw-text-primary-red">
          Choose Plan
        </div>
        <div className="tw-ml-12 tw-h-2 tw-flex-1 tw-bg-primary-red"></div>
      </div>
      <Offers
        offers={offers}
        selectedOfferCode={selectedOffer.code}
        setSelectedOffer={setSelectedOffer}
      />
    </div>
  );
};

export default MultipleOffers;
